import React, { useState } from 'react';
import { PACKAGES, getEditionPricing, getOfferPrice } from '../../Constants/Packages';
import { Button } from '../ui/Button';
import { FLASHOFFER } from '../../Constants/Const';
import { useBrand } from '../../Utils/BrandContext';
import { PAGE_EDITION_MAPPER, getPageActiveOffer } from '../../Constants/Packages';
import { isIOSMobileDevice } from '../../Utils/Utilities';
import IOSRestrictedModal from '../Common/IOSRestrictedModal';

const StickyPricingFooter = ({ onBuyNow, onGetOffer, pageName = "", forceOfferKey = null }) => {
    const { brand: activeBrand } = useBrand()
    const [showIOSModal, setShowIOSModal] = useState(false);

    const pageEditions = PAGE_EDITION_MAPPER[pageName?.toLowerCase()];
    const pkgId = pageEditions?.editionIds?.[0] ?? 36;

    const silverEdition = PACKAGES[pkgId];
    const activeOffer = getPageActiveOffer(pageName, forceOfferKey);
    const flashOfferOn = activeOffer?.offerKey === 'FLASH_EOD';
    const sundayOfferOn = activeOffer?.offerKey === 'SUNDAY';
    const d3OfferOn = activeOffer?.offerKey === 'D3';
    const hasAnyOffer = !!activeOffer && activeOffer?.offerKey !== 'FRESH';
    const offerPrice = getEditionPricing(silverEdition, activeOffer);
    const handleBuyNow = () => {
        localStorage.removeItem("cpnYY2");
        onBuyNow?.(pkgId);
    };
    // const handleGetOffer = (offerType) => {
    //     onGetOffer?.();
    //     const allDataRaw = localStorage.getItem('allData');
    //     if (!allDataRaw) { onBuyNow?.(pkgId); return; }
    //     const allData = JSON.parse(allDataRaw);
    //     const leadInfo = allData.info ? JSON.parse(allData.info) : [];
    //     localStorage.setItem("selEdn", pkgId);
    //     var couponCode = activeOffer?.couponCode || "";
    //     localStorage.setItem("selPrd", activeOffer?.planPeriod || "YY");
    //     localStorage.setItem("cpn", couponCode);
    //     localStorage.setItem("guidePG", window.location.pathname.substring(1));
    //     const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
    //     localStorage.setItem('cio', JSON.stringify(cioData));
    //     window.location.href = "/Html/External/BZPay.html";
    // };
    const handleGetOffer = (offerType) => {
        if (isIOSMobileDevice()) {
            setShowIOSModal(true);
            return;
        }
        onGetOffer?.();
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) { onBuyNow?.(pkgId); return; }
        const allData = JSON.parse(allDataRaw);
        const leadInfo = allData.info ? JSON.parse(allData.info) : [];
        localStorage.setItem("selEdn", pkgId);
        const isBogo = offerPrice?.isBogo;
        if (isBogo) {
            const bogoCoupon = activeOffer?.couponCode || "SPLBOGO";
            localStorage.setItem("selPrd", "YY2");
            localStorage.removeItem("cpn");
            localStorage.setItem("cpnYY2", bogoCoupon);
        } else {
            var couponCode = activeOffer?.couponCode || "";
            localStorage.setItem("selPrd", activeOffer?.planPeriod || "YY");
            localStorage.setItem("cpn", couponCode);
            localStorage.removeItem("cpnYY2");
        }
        localStorage.setItem("guidePG", window.location.pathname.substring(1));
        const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
        localStorage.setItem('cio', JSON.stringify(cioData));
        window.location.href = "/Html/External/BZPay.html";
    };
    if (!silverEdition) return null;

    return (
        <>
            <style>{`
        @keyframes flashBlink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
        .flash-blink { animation: flashBlink linear 3s infinite; }
      `}</style>

            {/* Mobile Only - Sticky Bottom Footer */}
            <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#f0f1f3] shadow-[0_-4px_24px_rgba(0,0,0,0.2)] px-3 py-3">

                {/* No Offer Layout */}
                {!hasAnyOffer && (
                    <div
                        className="flex items-center justify-between gap-3"
                        onClick={handleBuyNow}
                    >
                        <div>
                            <p className="text-xs text-red-500 font-medium leading-tight mb-0.5 pl-4">
                                {silverEdition?.baseAmtAfterDescStr ? 'Start 1st year @ just' : 'Everything @ just'}
                            </p>
                            <div className="flex items-baseline gap-1 flex-nowrap">
                                <span className="text-[20px] font-light text-text-secondary">₹</span>
                                <span className="text-[30px] font-semibold text-text-primary leading-none">
                                    {silverEdition?.baseAmtAfterDescStr ?? silverEdition.baseAmtStr}
                                </span>
                                {(silverEdition?.baseAmtAfterDescStr || (silverEdition.stdAmt && silverEdition.stdAmt > silverEdition.baseAmt)) && (
                                    <s className="text-[13px] text-gray-500 font-medium whitespace-nowrap">
                                        ₹ {silverEdition?.baseAmtAfterDescStr ? silverEdition.baseAmtStr : silverEdition.stdAmtStr}
                                    </s>
                                )}
                                <span className="text-[11px] text-text-secondary whitespace-nowrap pl-1">+GST</span>
                            </div>
                        </div>
                        <Button
                            onClick={(e) => { e.stopPropagation(); handleBuyNow(); }}
                            variant="primaryDarkBlue"
                            size="sm"
                            className="shrink-0"
                        >
                            Buy Now
                        </Button>
                    </div>
                )}

                {/* Common Offer Layout — works for all offer types */}
                {hasAnyOffer && (
                    <div
                        className="flex items-center justify-between gap-3"
                        onClick={() => handleGetOffer('any')}
                    >
                        <div>
                            <p className="text-[14px] text-red-500 font-medium leading-tight mb-1">
                                {(() => {
                                    if (offerPrice.isBogo) return 'BOGO Offer - Get 2 Years!';
                                    const pct = offerPrice.discountPercent;
                                    const showPct = pct >= 35 && pct <= 50;
                                    return showPct ? `Extra ${pct}% Off on 1st year` : 'Extra Discount on 1st year';
                                })()}
                            </p>
                            <div className="flex items-baseline gap-1 flex-nowrap">
                                {!offerPrice.isBogo &&
                                    <s className="text-[13px] text-text-secondary font-medium whitespace-nowrap">
                                        ₹ {offerPrice.strikePrice}
                                    </s>}
                                <span className="text-[20px] font-light text-text-secondary">₹</span>
                                <span className="text-[30px] font-semibold text-text-primary leading-none">
                                    {offerPrice.mainPrice}
                                </span>
                                <span className="text-[11px] text-text-secondary whitespace-nowrap pl-1">
                                    {offerPrice.isBogo ? 'for 2 years +GST' : '+GST'}
                                </span>
                            </div>
                            <p className="text-xs text-red-500 font-medium leading-tight mt-0.5 flash-blink">
                                {offerPrice.isBogo ? 'Limited Time BOGO - Ending Soon!' : `${offerPrice.offerLabel} Ending Soon!`}
                            </p>
                        </div>
                        <Button
                            onClick={(e) => { e.stopPropagation(); handleGetOffer('any'); }}
                            variant="primaryDarkBlue"
                            size="sm"
                            className="shrink-0 !py-2 !px-2 text-base"
                        >
                            Buy Now
                        </Button>
                    </div>
                )}

            </div>

            {/* Spacer so content isn't hidden behind sticky footer on mobile */}
            <div className="md:hidden h-[80px]" />
            <IOSRestrictedModal isOpen={showIOSModal} onClose={() => setShowIOSModal(false)} />
        </>
    );
};

export default StickyPricingFooter;